function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "dax-flag-uk",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#244185",
  cx: 16,
  cy: 16,
  r: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.29392114,6.27468264 L16.089,12.5136487 L28.7541173,6.33767109 C29.957956,7.9242534 30.8725389,9.74236048 31.4193141,11.7134405 L22.414,16.1046487 L31.3667373,20.4717289 C30.7964267,22.4349205 29.8601061,24.2423889 28.6365429,25.8153669 L15.929,19.6176487 L3.32538373,25.7662249 C2.10807753,24.1887358 1.17870273,22.3776808 0.615973363,20.4117739 L9.604,16.0266487 L0.60202265,11.6372606 C1.15847336,9.66942425 2.08198536,7.85568576 3.29392114,6.27468264 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.3410479,7.16416003 C29.7096049,7.71952179 30.0444108,8.29922407 30.3425391,8.90034039 L17.8511134,14.9924427 L31.0542404,21.4322463 C30.8263198,22.0637664 30.5597916,22.6768303 30.257505,23.2685889 L16.9791134,16.7914427 L16.3091134,18.1644427 L16.3701486,18.2906189 L2.73153457,24.9442508 C2.35789361,24.3910546 2.01793737,23.8132359 1.71460865,23.2137374 L14.1671134,17.1394427 L0.907953258,10.6736805 C1.13161444,10.03994 1.39406285,9.42450643 1.69244707,8.83023113 L14.3201134,14.9894427 L14.1232577,14.5861234 L14.9551134,14.1794427 L15.1918557,13.6954427 L15.5691134,13.8804427 Z",
  id: "Combined-Shape",
  fill: "#C20000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,0 C17.746494,0 19.4276309,0.279827255 21.0010218,0.797092995 L21,11 L31.2032361,10.9999793 C31.7202914,12.5730822 32,14.2538764 32,16 C32,17.746494 31.7201727,19.4276309 31.202907,21.0010218 L21,21 L21.0010218,31.202907 C19.4276309,31.7201727 17.746494,32 16,32 C14.2538764,32 12.5730822,31.7202914 10.9999793,31.2032361 L11,21 L0.797092995,21.0010218 C0.279827255,19.4276309 0,17.746494 0,16 C0,14.2538764 0.279708571,12.5730822 0.796763907,10.9999793 L11,11 L10.9999793,0.796763907 C12.5730822,0.279708571 14.2538764,0 16,0 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,0 C17.0256717,0 18.0288022,0.0965100476 19.000806,0.280944465 L19,13 L31.7192447,13.000191 C31.9035559,13.9718837 32,14.974679 32,16 C32,17.0256717 31.90349,18.0288022 31.7190555,19.000806 L19,19 L19.000806,31.7190555 C18.0288022,31.90349 17.0256717,32 16,32 C14.974679,32 13.9718837,31.9035559 13.000191,31.7192447 L13,19 L0.280944465,19.000806 C0.0965100476,18.0288022 0,17.0256717 0,16 C0,14.974679 0.0964440691,13.9718837 0.280755332,13.000191 L13,13 L13.000191,0.280755332 C13.9718837,0.0964440691 14.974679,0 16,0 Z",
  id: "Combined-Shape",
  fill: "#C20000"
}));

function SvgDaxFlagUk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UK") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxFlagUk);
export default __webpack_public_path__ + "static/media/dax-flag-uk.64609adb.svg";
export { ForwardRef as ReactComponent };